import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { StorageKey } from '~core/models/shared.models';

@Injectable()
export class StorageService {
  protected _platformId = inject(PLATFORM_ID);

  protected get _isPlatformBrowser(): boolean {
    return isPlatformBrowser(this._platformId);
  }

  saveKey(
    key: StorageKey,
    value: string | null | undefined,
    storage: 'session' | 'local' = 'session'
  ): void {
    if (!this._isPlatformBrowser) return;
    const storageFn = storage === 'local' ? localStorage : sessionStorage;
    if (!value) {
      storageFn.removeItem(key);
      return;
    }
    storageFn.setItem(key, value);
  }

  getKey(key: StorageKey): string | null {
    if (!this._isPlatformBrowser) return null;
    const keyValue = localStorage.getItem(key);
    return keyValue ? keyValue : sessionStorage.getItem(key);
  }
}
